<template>
    <div style="height: 100%" class="d-flex flex-column">
        <p class="text-display-small text-typography1 pt-1 mt-0 mb-3">
            {{ title }}
        </p>
        <CalcStatsChips :calcId="calcId" :noLeftMargin="true" />
        <div class="overflow-y-auto styled-scrollbar flex-shrink-1 flex-grow-0">
            <p class="text-body-large text-typography1 mt-0">
                {{ description }}
            </p>
        </div>
    </div>
</template>
<script setup>
import CalcStatsChips from './CalcStatsChips.vue'

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    description: {
        type: String,
        default: '',
    },
    calcId: {
        type: String,
        required: true,
    },
})
</script>
